import { render, staticRenderFns } from "./Favoritos.vue?vue&type=template&id=635f7327&scoped=true"
import script from "./Favoritos.vue?vue&type=script&lang=js"
export * from "./Favoritos.vue?vue&type=script&lang=js"
import style0 from "./Favoritos.vue?vue&type=style&index=0&id=635f7327&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635f7327",
  null
  
)

export default component.exports